import React, { useMemo } from 'react';

import Loading from '@src/components/ui2/Loading';
import { useAppSelector } from '@src/core/hooks';
import { getOrderCombinedCoupon, getOrderSaleItems, getOrderSummarySubtotalCurrencyInfo } from '@src/domains/orders';
import { currentOrderSelector } from '@src/features/orders';
import CurrencySelector from '../CurrencySelector';
import CurrencyWarning from '../CurrencyWarning';
import SaleSummaryContent from '../SaleSummary/SaleSummaryContent';

interface OrderSummaryProps {
  showTotal?: boolean;
  showPlaceholderImage?: boolean;
}

export const OrderSummary = (props: OrderSummaryProps) => {
  const { showTotal = false, showPlaceholderImage = false } = props;

  const order = useAppSelector(currentOrderSelector);

  const items = useMemo(() => (order ? getOrderSaleItems(order) : []), [order]);
  const coupon = useMemo(() => getOrderCombinedCoupon(order), [order]);

  return (
    <>
      <CurrencySelector />
      <CurrencyWarning />
      {order ? (
        <SaleSummaryContent
          items={items}
          subtotal={getOrderSummarySubtotalCurrencyInfo(order)}
          coupon={coupon}
          total={order.finalAmountCurrencyInfo}
          showTotal={showTotal}
          showPlaceholderImage={showPlaceholderImage}
        />
      ) : (
        <Loading />
      )}
    </>
  );
};

export default OrderSummary;
